import React, { useState } from "react";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { GetRfqTrnSupplyByKey } from "../queries/queries";
import {
  GetRfqTrnSupplyByKeyResult,
  GetRfqTrnSupplyByKeyVar,
} from "../queries/types";
import { useLazyQuery } from "@apollo/client";
import { emptyMessage } from "../../../../../../utils/constants";
import { msgType } from "../../../../../../utils/types";
import { Operation } from "../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../customComponents/MessageModal";

const QuotationLogin = () => {
  const navigate = useNavigate();

  const [GetRfqTrans, { data, loading, fetchMore }] = useLazyQuery<
    GetRfqTrnSupplyByKeyResult,
    GetRfqTrnSupplyByKeyVar
  >(GetRfqTrnSupplyByKey);

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [key, setKey] = useState("");

  return (
    <>
      <div className="quotation-login">
        <div className="quotation-login__block">
          <div className="quotation-login__block--header">
            <b>Quotation Request</b>
            <span>Login</span>
          </div>
          <div className="quotation-login__block--mid">
            <div className="quotation-login__block--mid--block">
              <Label>Enter Key</Label>
              <Input
                type="password"
                name="key"
                onChange={(e) => {
                  setKey(e.target.value);
                }}
              />
              <Button
                mode="continue"
                onClick={() => {
                  GetRfqTrans({
                    variables: {
                      key,
                    },
                  }).then(({ data }) => {
                    if (
                      data &&
                      data.GetRfqTrnSupplyByKey &&
                      data.GetRfqTrnSupplyByKey.length
                    ) {
                      navigate(`/vendor/${key}/quotationpreview`);
                    } else {
                      setMessage({
                        flag: true,
                        message: "Transaction Details not found",
                        operation: Operation.NONE,
                      });
                    }
                  });
                }}
              />
            </div>
          </div>

          <div className="quotation-login__block--footer">
            <span>if You login by given password it works only once </span>
          </div>
        </div>
      </div>
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default QuotationLogin;
